var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotInitatedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99966 6.61649V10.1421L13.5817 14.3165M9.99968 19.3088C15.0624 19.3088 19.1663 15.2048 19.1663 10.1421C19.1663 5.07952 15.0624 0.975464 9.99968 0.975464C4.93707 0.975464 0.833008 5.07952 0.833008 10.1421C0.833008 15.2048 4.93707 19.3088 9.99968 19.3088Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInitatedIcon);
export default __webpack_public_path__ + "static/media/notInitatedIcon.4ebd7de4a7932d3a0157ff73b062b844.svg";
export { ForwardRef as ReactComponent };